export const ADMIN_DASHBOARD_INSTRUCTIONS = 'ADMIN_DASHBOARD_INSTRUCTIONS';
